import ResponsiveModeButton from './ResponsiveModeButton';

export default ResponsiveModeButton;
